import React from 'react';

import { SlCheckbox, SlInput } from '@shoelace-style/shoelace/dist/react';

import { SmallButton } from '~shared/components/buttons';
import { toast } from '~shared/components/Toast';

import {
  AreasOfImprovementStep,
  GenerateQuestionsByAreaOfImprovementMutation,
} from './AreasOfImprovement';
import {
  GenerateQuestionDialogContent
} from "~teacher/components/ResultsGrid/Insights/GenerateQuestions/Layout/GenerateQuestionDialogContent";

interface SelectInsightsProps {
  backToGenerationType?: () => void;
  isGeneratingQuestions: boolean;
  setIsGeneratingQuestions: React.Dispatch<React.SetStateAction<boolean>>;
  generateQuestionsMutation: GenerateQuestionsByAreaOfImprovementMutation;
  selectedInsightId: Set<number>;
  questionsToGenerate: number;
  setAreaOfImprovementStep: React.Dispatch<
    React.SetStateAction<AreasOfImprovementStep>
  >;
  insights: Array<{
    type: string;
    description: string;
    insightId: number;
  }>;
  addInsightId: (insightId: number) => void;
  removeInsightId: (insightId: number) => void;
  setQuestionsToGenerate: React.Dispatch<React.SetStateAction<number>>;
}

export function SelectInsights({
  backToGenerationType,
  isGeneratingQuestions,
  setIsGeneratingQuestions,
  generateQuestionsMutation,
  selectedInsightId,
  questionsToGenerate,
  setAreaOfImprovementStep,
  insights,
  addInsightId,
  removeInsightId,
  setQuestionsToGenerate,
}: SelectInsightsProps) {
  return (
    <GenerateQuestionDialogContent
      header={
        <GenerateQuestionDialogContent.Header onBack={backToGenerationType}>
          Select Areas of Improvement to include in the assessment.
        </GenerateQuestionDialogContent.Header>
      }
      footer={
        <GenerateQuestionDialogContent.Footer>
          <SmallButton
            isLoading={isGeneratingQuestions}
            onClick={() => {
              setIsGeneratingQuestions(true);
              generateQuestionsMutation.mutate(
                {
                  selectedInsightId,
                  questionsToGenerate,
                },
                {
                  onError: () => {
                    toast.critical('Failed to generate questions');
                    setIsGeneratingQuestions(false);
                  },
                  onSuccess: () => {
                    setAreaOfImprovementStep('step2-select-questions');
                  },
                  onSettled: () => {
                    setIsGeneratingQuestions(false);
                  },
                }
              );
            }}
          >
            next
          </SmallButton>
        </GenerateQuestionDialogContent.Footer>
      }
    >
      <div className="flex flex-col gap-2">
        {insights.map(({ type, description, insightId }) => (
          <SlCheckbox
            key={insightId}
            role="checkbox"
            checked={selectedInsightId.has(insightId)}
            onSlChange={(e) => {
              const checked = (e.target as any).checked;
              if (checked) {
                addInsightId(insightId);
              } else {
                removeInsightId(insightId);
              }
            }}
          >
            <strong>{type}</strong>
            <span>{description}</span>
          </SlCheckbox>
        ))}
        <SlInput
          value={`${questionsToGenerate}`}
          onChange={(e) => {
            setQuestionsToGenerate(parseInt((e.target as any).value));
          }}
        />
      </div>
    </GenerateQuestionDialogContent>
  );
}
